import React from 'react';
import ContactContent from '../components/contact/ContactContent';

const ContactPage: React.FC = () => {
  return <ContactContent />;
};

export default ContactPage;
